<template>
    <div class="profile-layout">
        <headerMain layout="profile" />
        <main class="cabinet">
            <div class="user profile">
                <navbar/>
                <div class="router-section">
                    <transition name="fade" mode="out-in">
                        <router-view :key="$route.fullPath" />
                    </transition>
                </div>
            </div>
        </main>
        <modalSearch/>

        <footerMain/>
    </div>
</template>

<script>
import footerMain from '@/components/app/footerMain';
import headerMain from '@/components/app/headerMain';
import modalSearch from '@/components/app/modals/modal-search';
import navbar from '@/components/app/profile/navbar';

export default {
  name: 'profile-layout',
  components:{
    navbar, headerMain, footerMain, modalSearch
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>

<style lang="scss">
@import '~bootstrap/dist/css/bootstrap.min.css';
/*@import '../assets/sass/app/app.scss';*/
</style>
